"use strict";

// parts
import './parts/_accordion.js';
import './parts/_drawer.js';
import "./parts/_fixed-viewport.js";
import './parts/_tab-change.js';
